import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import { apiFetch } from "../api_call"; // ✅ use unified API

export default function EditDept() {
  const [menuOpen, setMenuOpen] = useState(false);

  const [formData, setFormData] = useState({
    departmentName: "",
    departmentId: "",
  });
  const [originalName, setOriginalName] = useState("");

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [errorVisible, setErrorVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user.usrlst_id;

  // ✅ Admin Auth
  useEffect(() => {
    if (!userId || user?.usrlst_role?.toLowerCase() !== "admin") {
      alert("Access denied.");
      navigate("/", { replace: true });
    }
  }, [navigate, userId, user]);

  // ✅ Load saved Department info
  useEffect(() => {
    const name = localStorage.getItem("editDeptName") || "";
    const id = localStorage.getItem("editDeptId") || "";
    setFormData({ departmentName: name, departmentId: id });
    setOriginalName(name);
  }, []);

  // ✅ Handle Input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Save Changes via /edit API
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.departmentName.trim()) {
      setErrors({ api: "Department name cannot be blank." });
      return;
    }

    setLoading(true);
    setErrors({});
    setSuccessMsg("");

    try {
      const payload = {
        department_name: formData.departmentName.trim(),
      };

      const data = await apiFetch(`/user/departments/edit/${formData.departmentId}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });

      // ✅ Only throw if error is non-zero or non-empty
      if (data.error && data.error !== "0") {
        throw new Error(data.error);
      }

      setSuccessMsg("✅ Department updated successfully!");
      setOriginalName(formData.departmentName);

      setTimeout(() => {
        navigate("/department");
      }, 1200);
    } catch (err) {
      console.error(err);
      setErrors({
        api: err?.message || "Failed to update department. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ✅ Auto-hide error
  useEffect(() => {
    if (errors.api) {
      setErrorVisible(true);
      const timer = setTimeout(() => setErrorVisible(false), 4500);
      const clearTimer = setTimeout(() => setErrors({}), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(clearTimer);
      };
    }
  }, [errors.api]);

  // ✅ Auto-hide success
  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const timer = setTimeout(() => setSuccessVisible(false), 4500);
      const clearTimer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(clearTimer);
      };
    }
  }, [successMsg]);

  // ✅ Dummy Delete button handler
  const handleDelete = () => {
    // Does nothing, purely dummy
    alert("Delete button clicked (dummy).");
  };

  return (
    <div className="edit-dept">
      <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Edit Department</h2>

        {/* ✅ Unified top messages */}
        <div className="messages-top" style={{ margin: "0 auto 1rem auto", width: "50%" }}>
          {errors.api && (
            <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
              {errors.api}
            </div>
          )}
          {successMsg && (
            <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          <label>
            Department Name
            <input
              type="text"
              name="departmentName"
              value={formData.departmentName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </label>

          <div className="action-buttons">
            <button
              type="submit"
              className="submit-btn"
              disabled={loading || formData.departmentName.trim() === originalName.trim()}
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>

            {/* ✅ Dummy Delete button */}
            <button
              type="button"
              className="submit-btn delete-btn"
              onClick={handleDelete}
            >
              Delete Department
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
